import { defineComponent, ref, computed, watch, createElementBlock, openBlock, normalizeClass, toDisplayString } from "vue";
const _hoisted_1 = ["src", "alt"];
const SHAPES = ["rectangle", "circle"];
const SHAPE_CLASSES = {
  rectangle: "rounded-lg",
  circle: "rounded-full"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PAvatar"
  },
  __name: "p-avatar",
  props: {
    shape: {
      type: String,
      default: "circle",
      validator: (value) => SHAPES.includes(value)
    },
    imageSrc: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: true
    },
    imageClass: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const imageBroken = ref(false);
    const shapeClass = computed(() => SHAPE_CLASSES[props.shape]);
    watch(
      () => props.imageSrc,
      () => {
        imageBroken.value = false;
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(shapeClass.value)
      }, [
        __props.imageSrc && !imageBroken.value ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: __props.imageSrc,
          alt: __props.label,
          class: normalizeClass(["h-full w-full object-cover", [shapeClass.value, __props.imageClass]]),
          onError: _cache[0] || (_cache[0] = ($event) => imageBroken.value = true)
        }, null, 42, _hoisted_1)) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["flex h-full w-full items-center justify-center", [shapeClass.value, __props.labelClass]])
        }, toDisplayString(__props.label), 3))
      ], 2);
    };
  }
});
export {
  _sfc_main as _
};
